import { Icon } from '@kontentino/ui';
import { ActionContext, createAction } from 'actions';
import i18n from 'app/utils/i18n';
import { UserPermission } from 'constants/userPermission';
import { faRefresh } from '@fortawesome/pro-regular-svg-icons/faRefresh';
import ReportApi from 'api/report';
import { ReportsQueryKey } from 'app/utils/queryKey';
import { queryClient } from 'api/client';

export const regenerateReport = (context: ActionContext) =>
  createAction(
    {
      id: 'regenerate-report',
      label: () => i18n.t('regenerate'),
      icon: <Icon icon={faRefresh} />,
      scopes: UserPermission.REPORT_EXPORT,
      perform: async ({
        id,
        queryKey,
      }: {
        id: number;
        queryKey?: ReturnType<typeof ReportsQueryKey>;
      }) => {
        const res = await ReportApi.createExport(id);
        if (!res) return;
        context.toast('The report will regenerate', 'success');
        if (queryKey) {
          queryClient.invalidateQueries([queryKey]);
        }
      },
    },
    context,
  );
